import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { addonsList } from '../../../store/Addons/Addons';
import product from '../../../helpers/product';
import useStores from '../../../store/StoreHook';

// UI
import UI from './Cross.ui';

const Cross = observer((props) => {
  const { catalogStore } = useStores();
  const [state, replaceState] = useState({
    addonsList: [],
    products: [],
  });

  const setState = data => replaceState(prevState => ({ ...prevState, ...data }));

  useEffect(() => {
    addonsList().then((res) => {
      if (res.success) {
        setState({ addonsList: res.data[0].filter(x => x.enabled === true && x.show_home === false) });
      }
    });
  }, []);

  useEffect(() => {
    const { catalogResponse, orderStore } = catalogStore;
    const products = (catalogResponse.data || []).filter((prod) => {
      for (let i = 0; i < prod.items.length; i += 1) {
        const item = prod.items[i];
        if (!item.available || !item.buyable || props.cartItems.some(ci => ci.part_number === item.part_number)) {
          return false;
        } else if (props.tipo === 'PLAN') {
          const itemAttr = product.convertAttributes(item.attributes);
          const tipo = itemAttr['attr-conf-tipoproducto'];
          const tipoplan = itemAttr['attr-conf-tipoplan'];
          if (tipoplan === 'musica' || tipoplan === 'video') {
            const plan = props.cartItems.find(ci => product.tipo(ci.product.items[0]) === 'PLAN');
            const planAttr = plan ? product.convertAttributes(plan.product.items[0].attributes) : {};
            if ((planAttr[`attr-paquete-${tipoplan}`] || '').toLowerCase() === 'si') {
              return false;
            } else {
              const itemsAddons = props.cartItems.filter(ci => product.tipo(ci.product.items[0]) === 'ADDONS');
              for (let j = 0; j < itemsAddons.length; j += 1) {
                const itemAddon = itemsAddons[j];
                const addonAttr = product.convertAttributes(itemAddon.product.items[0].attributes);
                if ((addonAttr['attr-conf-tipoplan'] || '') === tipoplan) {
                  return false;
                }
              }
            }
          } else if (tipo === 'GARANTIA') {
            const pospago = props.cartItems.find(ci => product.tipo(ci.product.items[0]) === 'POSPAGO');
            if (pospago) {
              const sp = pospago.part_number_kit.split('--');
              const plan = sp[1];
              const plazo = sp[2];
              const filtro = itemAttr['filt-precio'].split('-');
              const minimo = parseFloat(filtro[0].trim().replace(`${process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}.`, ''));
              const maximo = parseFloat(filtro[1].trim().replace(`${process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}.`, ''));
              const precio = pospago.product.items[0].pricing.pospago[plan][plazo].offer_price;
              item.add = (itemAttr['attr-conf-obligatorio'] || '').toUpperCase() === 'SI';
              return (precio >= minimo && precio <= maximo);
            }
            return false;
          }
        } else if (props.tipo === 'PREPAGO') {
          const itemAttr = product.convertAttributes(item.attributes);
          const tipo = itemAttr['attr-conf-tipoproducto'];
          const tipoplan = (itemAttr['attr-conf-tipoplan'] || '').toUpperCase();
          if (tipo === 'PLAN' && tipoplan === 'FIJO') {
            return false;
          }
        }
      }
      return true;
    });
    async function init() {
      const prods = [];
      for (let i = 0; i < products.length; i += 1) {
        const item = products[i].items[0];
        if (item.add) {
          if (i === products.length - 1) {
            props.addToCart(item);
          } else {
            await orderStore.addToCart({
              part_number: item.part_number,
              quantity: 1,
            });
          }
        } else {
          prods.push(products[i]);
        }
      }
      setState({ products: prods });
    }
    init();
  }, [catalogStore.catalogResponse]);

  return (
    <UI products={state.products} addOnsList={state.addonsList} tipo={props.tipo} addToCart={props.addToCart} />
  );
});

export default Cross;
